module.exports = require("@bechtel/client-assets/dist/images/rod-room-icon.svg");